import { useNavigate } from 'react-router-dom';
import { useAnimatedDialogHandler } from './shared/Dialog/useAnimatedDialogHandler';
import { ComponentType, ReactNode } from 'react';
import { StickyBottom } from './shared/StickyBottom/StickyBottom';
import { Button, ButtonProps } from './shared/Button/Button';
import InfoIcon from '../assets/info-icon.svg?react';

type WithOrderSummaryLayoutProps = {
  children: ReactNode;
  sideContent: (closeDialog?: () => void) => ReactNode;
  showButton?: boolean;
  CustomButton?: ComponentType<Omit<ButtonProps, 'children'>>;
};

export const WithOrderSummaryLayout = ({
  children,
  sideContent,
  showButton,
  CustomButton,
}: WithOrderSummaryLayoutProps) => {
  const { ref, isOpen, openDialog, closeDialog } = useAnimatedDialogHandler(300);

  const navigate = useNavigate();

  const proceed = () => {
    // navigate('/services');
    navigate('/form');
  };

  const DefaultButton = (props: Omit<ButtonProps, 'children'>) => (
    <Button {...props} onClick={proceed}>
      Далее
    </Button>
  );

  const BottomButton = CustomButton ?? DefaultButton;

  return (
    <main className="container mx-auto max-w-[1168px]">
      <div className="xl:mt-10 xl:grid xl:grid-cols-fixed-right">
        <section className="p-5 xl:mr-6 xl:p-8 xl:pt-0">{children}</section>

        <section className="sticky top-8 hidden h-fit bg-neutral-10 p-8 xl:block">
          {sideContent()}
        </section>
      </div>
      <dialog
        ref={ref}
        className={`custom-popup m-0 h-full max-h-full w-full max-w-full bg-neutral-0/0 xl:hidden ${isOpen && 'open'}`}
      >
        <div
          className={`fixed bottom-0 table-cell h-full w-full max-w-full overflow-x-auto bg-neutral-0 p-5`}
        >
          {sideContent(closeDialog)}
        </div>
      </dialog>

      {showButton && (
        <StickyBottom className="hidden xl:block">
          <BottomButton />
        </StickyBottom>
      )}

      <StickyBottom className="xl:hidden">
        {showButton && <BottomButton className="mb-3 w-full" />}

        <div className="flex items-center justify-center">
          <p className="mr-2 text-lg text-neutral-900" onClick={openDialog}>
            Информация о заказе
          </p>
          <InfoIcon />
        </div>
      </StickyBottom>
    </main>
  );
};
